import {
    CreateTaskSubTicketInput,
    UpdateTaskSubTicketInput,
} from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/inputs';

import { normalizeExpectedDeliverables } from './expectedDeliverables';

export interface SubTicketFormValues {
    scope: string;
    expectedDeliverables: string[];

    // Null when the phase is planned without a due date. It is a real answer, not a missing
    // one, so it travels as an explicit `due_at: null` rather than a dropped key or an
    // invented default — see the payload builders below
    dueAt: string | null;
}

// Exactly the four management inputs reach the wire. There is deliberately no title and no
// scope summary: the summary is derived server-side from the scope on every write and is
// rejected outright if a client sends it, which is what stops it becoming a hidden fifth input.
//
// `due_at` is written unconditionally, null included. The endpoint requires the KEY and reads
// an explicit null as "no due date", so a conditional spread would turn "no due date" into a
// 400 — and defaulting it to today would put a deadline on the designer that nobody chose.
export const buildCreateSubTicketPayload = (
    taskId: ID,
    assigneeUserId: ID,
    values: SubTicketFormValues
): CreateTaskSubTicketInput => ({
    task_id: taskId,
    scope: values.scope,
    expected_deliverables: normalizeExpectedDeliverables(values.expectedDeliverables),
    due_at: values.dueAt,
    assignee_user_id: assigneeUserId,
});

// The assignee is deliberately absent from the update payload: reassignment is its own
// endpoint because it is refused while a timer runs, and folding it in here would make editing
// a scope silently capable of moving the work to another designer.
export const buildUpdateSubTicketPayload = (values: SubTicketFormValues): UpdateTaskSubTicketInput => ({
    scope: values.scope,
    expected_deliverables: normalizeExpectedDeliverables(values.expectedDeliverables),
    due_at: values.dueAt,
});
